<template>
  <div class="garanties-list">
    <div class="clients__title">Modifier les informations d'assistance</div>

    <template v-if="isLoading">
      <Preloader />
    </template>
    <template v-else>
      <form name="client_edit">
        <div class="portlet-merchant__body p-0">
          <div class="mt-0 mb-5">
            <div class="row">
              <div class="col-12">
                <div class="portlet-merchant__body__block mb-5">
                  <div class="row margin-bottom">
                    <div class="col-12">
                      <div class="form_ttl_first">INFO</div>
                    </div>
                    <!-- TYPE -->
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">TYPE:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          <template v-if="isAutoCarQuote"> Autocar </template>
                          <template v-else-if="isPoidsLourdsQuote">
                            Poids Lourds
                          </template>
                          <template v-else-if="isTaxiQuote">
                            Taxi - Ambulance - Corbillard - VSL
                          </template>
                          <template v-else-if="isVULVLQuote">
                            VU - VL
                          </template>
                          <template v-else-if="isVUL4097Quote">
                            VUL - 4097
                          </template>
                        </div>
                      </div>
                    </div>
                    <!-- CREATED AT -->
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title text-primary">CRÉÉ LE:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ formatDate(assistance.created_at, "DD/MM/YYYY") }}
                        </div>
                      </div>
                    </div>
                    <!-- Effective Date  -->
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title text-primary">DATE PRISE D'EFFET:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{
                            formatDate(assistance.effective_date, "DD/MM/YYYY")
                          }}
                        </div>
                      </div>
                    </div>
                    <!-- Original Price START -->
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title text-primary">PRIME ÉMISE:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{
                            assistance.price
                              ? parseFloat(assistance.price).toFixed(2) + " &euro; "
                              : "0.00 &euro;"
                          }}
                        </div>
                      </div>
                    </div>
                    <!-- Nb Vehicles  -->
                    <div class="col-12 col-md-3 mt-5" v-if="assistance.nb_vehicles">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title text-primary">NOMBRE DE VÉHICULES
                          ASSISTÉS:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ assistance.nb_vehicles }}
                        </div>
                      </div>
                    </div>

                    <!-- Options Autocar  -->
                    <div class="col-12 col-md-3 mt-5" v-if="isAutoCarQuote">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title text-primary">OPTIONS SOUSCRITES:</span>
                        <div class="portlet-merchant__body__block__info--text" v-if="assistance.nb_vehicles_base">
                          Aucune
                        </div>
                        <div class="portlet-merchant__body__block__info--text"
                          v-else-if="assistance.nb_vehicles_option1">
                          Dépannage/remorquage avec prise en charge à
                          concurrence de 2500 € TTC
                        </div>
                        <div class="portlet-merchant__body__block__info--text"
                          v-else-if="assistance.nb_vehicles_option2">
                          Dépannage/remorquage avec prise en charge à
                          concurrence de 4000 € TTC
                        </div>
                        <div class="portlet-merchant__body__block__info--text"
                          v-else-if="assistance.nb_vehicles_option3">
                          Véhicule de remplacement max 3 jours à concurrence de
                          500€ TTC/jour
                        </div>
                        <div class="portlet-merchant__body__block__info--text"
                          v-else-if="assistance.nb_vehicles_option4">
                          Dépannage/remorquage avec prise en charge à
                          concurrence de 2500 € TTC<br />Véhicule de
                          remplacement max 3 jours à concurrence de 500€
                          TTC/jour
                        </div>
                        <div class="portlet-merchant__body__block__info--text"
                          v-else-if="assistance.nb_vehicles_option5">
                          Dépannage/remorquage avec prise en charge à
                          concurrence de 4000 € TTC<br />Véhicule de
                          remplacement max 3 jours à concurrence de 500€
                          TTC/jour
                        </div>
                      </div>
                    </div>
                    <!-- Options Autocar END -->

                    <!-- Options Poids Lourds  -->
                    <div class="col-12 col-md-3 mt-5" v-if="isPoidsLourdsQuote">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title text-primary">OPTIONS SOUSCRITES:</span>
                        <div class="portlet-merchant__body__block__info--text" v-if="assistance.nb_vehicles_base">
                          Aucune
                        </div>
                        <div class="portlet-merchant__body__block__info--text"
                          v-else-if="assistance.nb_vehicles_option1">
                          Dépannage/Remorquage 2500 euros
                        </div>
                        <div class="portlet-merchant__body__block__info--text"
                          v-else-if="assistance.nb_vehicles_option2">
                          Dépannage/Remorquage 4000 euros
                        </div>
                      </div>
                    </div>
                    <!-- Options Poids Lourds -->

                    <!-- Options VSL  -->
                    <div class="col-12 col-md-3 mt-5" v-if="isTaxiQuote">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title text-primary">OPTIONS SOUSCRITES:</span>
                        <div class="portlet-merchant__body__block__info--text" v-if="assistance.nb_vehicles_base">
                          Option 1 : Franchise 0km<br />
                          Option 2 : Dépannage/Remorquage 300 euros
                        </div>
                      </div>
                    </div>
                    <!-- Options VSL END -->

                    <!-- Options VUL  -->
                    <div class="col-12 col-md-3 mt-5" v-if="isVULVLQuote">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title text-primary">OPTIONS SOUSCRITES:</span>
                        <div class="portlet-merchant__body__block__info--text" v-if="assistance.nb_vehicles_base">
                          Dépannage/Remorquage 150 euros
                        </div>
                        <div class="portlet-merchant__body__block__info--text"
                          v-else-if="assistance.nb_vehicles_option1">
                          Option 1 : Dépannage/Remorquage 300 euros
                        </div>
                        <div class="portlet-merchant__body__block__info--text"
                          v-else-if="assistance.nb_vehicles_option2">
                          Option 2 : Franchise 0km
                        </div>
                        <div class="portlet-merchant__body__block__info--text"
                          v-else-if="assistance.nb_vehicles_option3">
                          Option 3 : Franchise 0km et Dépannage/Remorquage 300
                          euros
                        </div>
                      </div>
                    </div>
                    <!-- Options VUL END -->

                    <!-- Options VUL - 4097  -->
                    <div class="col-12 col-md-3 mt-5" v-if="isVUL4097Quote">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title text-primary">OPTIONS SOUSCRITES:</span>
                        <div class="portlet-merchant__body__block__info--text" v-if="assistance.nb_vehicles_base">
                          Franchise 0km et Dépannage/Remorquage 300 euros
                        </div>
                      </div>
                    </div>
                    <!-- Options VUL - 4097 END -->
                    <!-- PRICE -->
                    <div class="col-12 col-md-3 mt-5" v-if="assistance.assistance_price">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title text-primary">PRIX:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{
                            assistance.assistance_price
                              ? parseFloat(assistance.assistance_price).toFixed(2) + " &euro; "
                              : "0.00 &euro;"
                          }}
                        </div>
                      </div>
                    </div>
                    <!-- COMMISSION START -->
                    <!-- <div
                      class="col-12 col-md-3 mt-5"
                      v-if="
                        assistance.mechanic &&
                        assistance.mechanic.representative
                      "
                    >
                      <div class="portlet-merchant__body__block__info font-13">
                        <span
                          class="portlet-merchant__body__block__info--title text-primary"
                          >COMMISSION:</span
                        >
                        <div class="portlet-merchant__body__block__info--text">
                          {{ formatCommission(assistance) + " &euro; " }}
                        </div>
                      </div>
                    </div> -->
                    <!-- COMMISSION END -->
                  </div>

                  <div class="row margin-bottom">
                    <div class="col-12">
                      <div class="form_ttl_first">INFORMATIONS CLIENT</div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">NOM DU
                          SOUSCRIPTEUR:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ assistance.client.name_of_signatory }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">NOM:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ assistance.client.last_name }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">PRÉNOM:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ assistance.client.first_name }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">ADRESSE:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ assistance.client.address }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 mt-5">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">Code
                          Postal:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ assistance.client.zip }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 mt-5">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">Ville:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ assistance.client.city }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 mt-5">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">Email:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ assistance.client.email }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 mt-5">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">TÉLÉPHONE:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ assistance.client.tel }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row margin-bottom">
                    <div class="col-12">
                      <div class="form_ttl_first">DÉTAILS GARANTIE</div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">DATE PRISE
                          D'EFFET:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{
                            formatDate(assistance.effective_date, "DD/MM/YYYY")
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">DATE DE FIN DE
                          CONTRAT:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{
                            formatDate(
                              assistance.effective_date_end,
                              "DD/MM/YYYY"
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">DATE DE PROCHAINE
                          ÉCHÉANCE:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{
                            formatNextDate(
                              assistance.effective_date_end,
                              "DD/MM/YYYY"
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">STATUT:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ getStatus(assistance.status) }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 mt-5">
                      <div class="portlet-merchant__body__block__info font-13" v-if="assistance.status == 'Inactive'">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">DATE
                          D'ANNULATION:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{
                            formatDate(
                              assistance.cancellation_date,
                              "DD/MM/YYYY"
                            )
                          }}
                        </div>
                      </div>
                      <div class="portlet-merchant__body__block__info font-13" v-if="
                        assistance.status == 'Resiliated' ||
                        assistance.status == 'Resiliated_Non_Payment' ||
                        assistance.status == 'Resiliated_Expired' ||
                        assistance.status == 'Resiliated_Sold'
                      ">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">DATE DE
                          RÉSILIATION:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{
                            formatDate(
                              assistance.cancellation_date,
                              "DD/MM/YYYY"
                            )
                          }}
                        </div>
                      </div>
                      <div class="portlet-merchant__body__block__info font-13"
                        v-else-if="assistance.status == 'Waiting_Payment'">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">DATE D'ENVOI DE
                          QUITTANCE:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{
                            formatDate(assistance.mailing_date, "DD/MM/YYYY")
                          }}
                        </div>
                      </div>
                      <div class="portlet-merchant__body__block__info font-13"
                        v-else-if="assistance.status == 'Relance'">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">DATE DE
                          RELANCE:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{
                            formatDate(assistance.mailing_date, "DD/MM/YYYY")
                          }}
                        </div>
                      </div>
                      <div class="portlet-merchant__body__block__info font-13"
                        v-else-if="assistance.status == 'Formal_Notice'">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">MISE EN
                          DEMEURE:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{
                            formatDate(assistance.mailing_date, "DD/MM/YYYY")
                          }}
                        </div>
                      </div>
                      <div class="portlet-merchant__body__block__info font-13"
                        v-else-if="assistance.status == 'Active'">
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">DATE DE MISE À
                          JOUR:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ formatDate(assistance.updated_at, "DD/MM/YYYY") }}
                        </div>
                      </div>
                      <div class="portlet-merchant__body__block__info font-13" v-else>
                        <span class="portlet-merchant__body__block__info--title fw-bold text-primary">DATE DE MISE À
                          JOUR:</span>
                        <div class="portlet-merchant__body__block__info--text">
                          {{ formatDate(assistance.updated_at, "DD/MM/YYYY") }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-12 col-md-3 mt-5">
                      <div class="portlet-merchant__body__block__info font-13">
                        <span
                          class="portlet-merchant__body__block__info--title fw-bold text-primary"
                          >RÉPONSE:</span
                        >
                        <div class="portlet-merchant__body__block__info--text">
                          {{ getResponse(assistance.response) }}
                        </div>
                      </div>
                    </div> -->
                  </div>
                  <div class="row margin-bottom">
                    <div class="col-12">
                      <div class="form_ttl_first">INFORMATIONS DE PAIEMENT</div>
                    </div>
                    <div class="col-12">
                      <template>
                        <div class="clients__table" style="margin-left: 10px">
                          <template v-if="assistance.payments.length > 0">
                            <div class="clients__table__item">
                              <div class="clients__table__item--cell small_wider text-primary">
                                Date De Paiement
                              </div>
                              <div class="clients__table__item--cell small_wider text-primary">
                                MONTANT RÉGLÉ
                              </div>
                              <div class="clients__table__item--cell small_wider text-primary">
                                COMMISSION DÉDUITE
                              </div>
                            </div>
                            <div class="clients__table__item" v-for="(payment, index) in assistance.payments"
                              :key="index">
                              <div class="clients__table__item--cell small_wider">
                                {{
                                  formatDate(payment.payment_date, "DD/MM/YYYY")
                                }}
                              </div>
                              <div class="clients__table__item--cell small_wider">
                                {{ payment.amount_paid ? payment.amount_paid + ' €' : '' }}
                              </div>
                              <div class="clients__table__item--cell small_wider">
                                {{
                                  payment.commission_included == 1 ? "Oui" : "Non"
                                }}
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <div class="subscribes-empty">
                              Aucune prime encaissée à ce jour
                            </div>
                          </template>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="row margin-bottom">
                    <div class="col-12">
                      <div class="form_ttl_first">
                        INFORMATIONS SUR LES VÉHICULES
                      </div>
                    </div>
                    <div class="col-6 col-md-3 mb-5" v-if="isButtonDisabled !== 'blocked'">
                      <div class="portlet-merchant__body__block__filter">
                        <div class="portlet-merchant__body__block__filter__content">
                          <div class="portlet-merchant__body__block__filter__content--item">
                            <button class="btn btn-block button blue" @click.prevent="addVehicleModal">
                              AJOUTER UN VÉHICULE
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <template>
                        <div class="clients__table" style="margin-left: 10px; overflow: auto;">
                          <template v-if="assistanceVehicles.length > 0">
                            <div class="clients__table__item">
                              <div class="clients__table__item--cell text-primary">
                                VÉHICULE
                              </div>
                              <div class="clients__table__item--cell text-primary">
                                MODÈLE
                              </div>
                              <div class="clients__table__item--cell text-primary">
                                IMMATRICULATION
                              </div>
                              <div class="clients__table__item--cell text-primary">
                                DATE DE 1ÈRE MISE EN CIRCULATION
                              </div>
                              <div class="clients__table__item--cell text-primary">
                                DATE ENTRÉE PARC
                              </div>
                              <div class="clients__table__item--cell text-primary">
                                DATE SORTIE PARC
                              </div>
                              <div class="clients__table__item--cell text-primary" style="text-align: center"
                                v-if="isButtonDisabled !== 'blocked'">
                                Action
                              </div>
                            </div>
                            <div class="clients__table__item" v-for="(vehicle, index) in assistanceVehicles"
                              :key="index">
                              <div class="clients__table__item--cell">
                                {{ vehicle.car_brand ? vehicle.car_brand : "" }}
                              </div>
                              <div class="clients__table__item--cell">
                                {{
                                  vehicle.modele_porteur
                                    ? vehicle.modele_porteur
                                    : ""
                                }}
                              </div>
                              <div class="clients__table__item--cell">
                                {{
                                  vehicle.registration ? vehicle.registration : ""
                                }}
                              </div>
                              <div class="clients__table__item--cell">
                                {{
                                  vehicle.day_circulation
                                    ? formatDateOf1stUse(
                                      vehicle.day_circulation,
                                      vehicle.month_circulation,
                                      vehicle.year_circulation
                                    )
                                    : ""
                                }}
                              </div>
                              <div class="clients__table__item--cell">
                                {{
                                  vehicle.date_entry
                                    ? $root.formatDate(vehicle.date_entry)
                                    : ""
                                }}
                              </div>
                              <div class="clients__table__item--cell">
                                {{
                                  vehicle.date_exit
                                    ? $root.formatDate(vehicle.date_exit)
                                    : "EN COURS"
                                }}
                              </div>
                              <div class="clients__table__item--cell icon-cell" style="text-align: center"
                                v-if="isButtonDisabled !== 'blocked' && !vehicle.date_exit">
                                <font-awesome-icon prefix="fas" icon="trash"
                                  @click.prevent="deleteVehicleModal(vehicle.id)" />
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <div class="subscribes-empty">
                              Il n'y a pas de véhicules pour cette assistance à ce
                              jour.
                            </div>
                          </template>
                        </div>
                      </template>
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-12">
                      <div class="form_ttl_first">INTERMÉDIAIRE</div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info">
                        <span
                          class="portlet-merchant__body__block__info--title fw-bold text-primary"
                          >INTERMÉDIAIRE:</span
                        >
                        <div class="portlet-merchant__body__block__info--text">
                          {{ assistance.mechanic.garage }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info">
                        <span
                          class="portlet-merchant__body__block__info--title fw-bold text-primary"
                          >CODE INTERMÉDIAIRE:</span
                        >
                        <div class="portlet-merchant__body__block__info--text">
                          {{ assistance.mechanic.code }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="portlet-merchant__body__block__info">
                        <span
                          class="portlet-merchant__body__block__info--title fw-bold text-primary"
                          >RÉSEAUX:</span
                        >
                        <div class="portlet-merchant__body__block__info--text">
                          {{ assistance.mechanic.representative.name }}
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <AddVehicleModal v-show="newVehicleModal" @close="closeVehicleModal" @update-list="updateData" />
            <DeleteVehicleModal v-show="isDeleteVehicleModal" :car="selectedCar" @close="closeDeleteModal"
              @update-list="updateData" />
          </div>
        </div>
        <!-- <ValidationErrors :errorsList="errors"/> -->
      </form>
    </template>
  </div>
</template>

<script>
import Preloader from "@/components/Preloader";
import AddVehicleModal from "@/components/GarantiesSouscrites/AddVehicleModal"
import DeleteVehicleModal from "@/components/GarantiesSouscrites/DeleteVehicleModal"
const blockedQuoteResponsesList = [2, 4, 5, 6];
export default {
  name: "AssistancesDetails",
  components: { Preloader, AddVehicleModal, DeleteVehicleModal },
  mixins: [],
  data() {
    return {
      isLoading: false,
      assistance: {},
      assistanceVehicles: {},
      newVehicleModal: false,
      isDeleteVehicleModal: false,
      selectedCar: 0,
    };
  },
  computed: {
    assistancesId() {
      return this.$route.params.id;
    },
    isAutoCarQuote() {
      return +this.assistance.type == 1;
    },
    isPoidsLourdsQuote() {
      return +this.assistance.type == 2;
    },
    isTaxiQuote() {
      return +this.assistance.type == 3;
    },
    isVULVLQuote() {
      return +this.assistance.type == 4;
    },
    isVUL4097Quote() {
      return +this.assistance.type == 5;
    },
    isButtonDisabled() {
      let date_check = this.moment(new Date()).format("YYYY-MM-DD");
      let date_end = this.moment(this.assistance.effective_date_end).format("YYYY-MM-DD");
      const isExpired = date_end < date_check;
      if (
        this.assistance.status === "Inactive" ||
        this.assistance.status === "Expired" ||
        this.assistance.status === "Resiliated" ||
        this.assistance.status === "Resiliated_Non_Payment" ||
        this.assistance.status === "Resiliated_Sold" ||
        isExpired ||
        blockedQuoteResponsesList.includes(+this.assistance.response)
      ) {
        return "blocked";
      }
    },
  },
  watch: {},
  methods: {
    getAssistances() {
      this.isLoading = true;
      let url = "mutuaide/" + this.assistancesId;
      this.apiGet(url)
        .then((response) => {
          this.isLoading = false;
          this.assistance = response.data.quote;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
        });
    },
    formatCommission(assistance) {
      let price;
      let commission;
      if (assistance.amount_paid) {
        price = assistance.amount_paid;
      } else if (assistance.price) {
        price = assistance.price;
      } else {
        price = assistance.assistance_price;
      }

      if (assistance.type == 1 || assistance.type == 2) {
        commission =
          (price * assistance.mechanic.representative.commission) / 100;
      } else if (assistance.type == 5) {
        commission =
          (((price - price / 10) / 1.18) *
            assistance.mechanic.representative.commission) /
          100;
      } else {
        commission =
          ((price / 1.18) * assistance.mechanic.representative.commission) /
          100;
      }

      return commission.toFixed(2);
    },
    getResponse(response) {
      if (response == 0) {
        return "Vide";
      } else if (response == 1) {
        return "Renouvelé";
      } else if (response == 2) {
        return "Résilié";
      } else if (response == 3) {
        return "NPAI";
      } else if (response == 4) {
        return "Résilié pour non paiement";
      } else if (response == 5) {
        return "Résilié à l'échéance";
      } else if (response == 6) {
        return "Résilié pour vente";
      } else {
        return "-";
      }
    },
    getQuotes() {
      let url = `mutuaide/assistanceslist/` + this.assistancesId,
        data = {
          per_page: "All",
        };

      this.apiGet(url, data)
        .then((response) => {
          this.assistanceVehicles = response.data.data;
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },
    formatDateOf1stUse(d, m, y) {
      let day = d.length > 1 ? d : 0 + d;
      let month = m.length > 1 ? m : 0 + m;
      return `${day}/${month}/${y}`;
    },
    addVehicleModal() {
      this.newVehicleModal = true;
    },
    closeVehicleModal() {
      this.newVehicleModal = false;
    },
    deleteVehicleModal(carId) {
      this.selectedCar = carId;
      this.isDeleteVehicleModal = true;
    },
    closeDeleteModal() {
      this.isDeleteVehicleModal = false;
    },
    getStatus(status) {
      if (status == 'Active') {
        return 'Valide';
      }
      else if (status == 'Inactive') {
        return 'Annulé';
      }
      else if (status == 'Expired') {
        return 'Échu';
      }
      else if (status == 'Waiting_Payment') {
        return 'Règlement en attente';
      }
      else if (status == 'Relance') {
        return 'Relance envoyée';
      }
      else if (status == 'Formal_Notice') {
        return 'Mise en demeure';
      }
      else if (status == 'Resiliated') {
        return 'Résilié';
      }
      else if (status == 'Resiliated_Non_Payment') {
        return 'Résilié pour non paiement';
      }
      else if (status == 'Resiliated_Expired') {
        return 'Résilié à l\'échéance';
      } else if (status == 'Regul_Waiting_Payment') {
        return 'Régul. en attente de règlement'
      }
      else {
        return 'Résilié pour vente'
      }
    },
    updateData() {
      this.getAssistances();
      this.getQuotes();
    }
  },
  mounted() {
    this.getAssistances();
    this.getQuotes();
  },
};
</script>
<style scoped>
.font-13 {
  font-size: 13px;
}

.margin-bottom {
  margin-bottom: 30px;
}

.clients__table__item--cell {
  width: 17% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/GarantiesSouscrites/AssistancesDetails.vue